import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=cb183e4e&"
import script from "./AppImage.js?vue&type=script&lang=js&"
export * from "./AppImage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports